import { render } from "./sql.vue?vue&type=template&id=9657460e"
import script from "./sql.vue?vue&type=script&lang=js"
export * from "./sql.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__